import Vue from 'vue'
import App from './App.vue'
import { router } from './router/index'
import apis from './apis/index';
import utils from "@/utils";
import i18n from './langs/index'
import Vant from 'vant'
import 'vant/lib/index.css'
// // normalize
import "normalize.css";

import store from './store/index'

Vue.config.productionTip = false

// 引入全局config，用于页面中不同平台
Vue.prototype.$siteConfig = require('@configs')
// 当前所开发或者编译的平台，可以在任意组件中通过 this.$region 获取到
Vue.prototype.$region = process.env.VUE_APP_REGION
// 发行地区
Vue.prototype.$area = process.env.VUE_APP_AREA
Vue.prototype.$distribution = process.env.VUE_APP_DISTRIBUTION
Vue.prototype.$regionIndex = process.env.VUE_APP_SOURCE

Vue.prototype.$apis = apis;

Vue.prototype.$utils = utils;

if (process.env.VUE_APP_AREA === 'komoe-sea') {
    const font = document.createElement('link')
    font.setAttribute('rel', 'stylesheet')
    font.href = 'https://fonts.googleapis.com/css?family=Noto+Sans+SC:100,300,400,500,700,900'
    document.head.appendChild(font)
}
Vue.use(Vant)
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')